module.exports = __webpack_public_path__ + "static/img/ys-2.f6742ec.webp";


//////////////////
// WEBPACK FOOTER
// ./static/images/ys-2.webp
// module id = HrEQ
// module chunks = 11